const urlUp = new URL(window.location);

const appConf = {
  //csvDir: "https://www.kvberlin.de/fileadmin/arztsuche/optionlists/",
  csvDir: "/fileadmin/arztsuche/optionlists/",
  jsonDump: "http://localhost:8888/arztsuche2.0/public/newdump.json",
  baseUrl: window.location.origin,
  debug:
    window.location.hostname.indexOf("localhost") >= 0 ||
    location.port == "8888" ||
    window.location.hostname.indexOf("stag") >= 0 ||
    window.location.href.indexOf("debugit") >= 0 ||
    urlUp.searchParams.get('pass') === "999000"
      ? true
      : false,
  local: window.location.hostname.indexOf("localhost") > -1 ? true : false,
  searchParams: urlUp.searchParams,
  html2pdfConf: {
    filename: "Arzt-_und_Psychotherapeutensuche_der_KV_Berlin.pdf",
    margin: [0,0,0,0],
    html2canvas: {
      scale: 1,
      backgroundColor: "#c2c2c2",
      imageTimeout: 10,
      logging: true,
      width: 800,
      windowWidth: 800,
      letterRendering: true,
    },
    pagebreak:{
      mode: ['css'],
      avoid: 'div.recgrid-item'
  },
    jsPDF: {
      unit: "mm",
      format: "A4",
      orientation: "portrait",
      putOnlyUsedFonts: true,
    },
  },
};

export default appConf;
